import { colorBaseGreyWarm50, layoutMarginSmall, Logo, ProductParagraph } from '@issuu/silkscreen';
import React from 'react';
import styled from 'styled-components';

import { NextDoc } from './NextDoc';

const LogoGraphic = styled.div`
    display: flex;
    height: 16px;
    width: 10em;
    margin: ${layoutMarginSmall} 0;
    justify-content: space-between;
    svg {
        width: 50%;
    }
`;

const BottomPart = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${colorBaseGreyWarm50};
`;

type Props = {
    onClose: () => void;
    countdownSecs: number;
};

export const InterstitialBottomPart: React.FC<Props> = ({ onClose, countdownSecs }) => {
    return (
        <BottomPart>
            <NextDoc countdownSecs={countdownSecs} onClose={onClose} />
            <LogoGraphic>
                <ProductParagraph step="negative-2">Powered by</ProductParagraph>
                <Logo />
            </LogoGraphic>
        </BottomPart>
    );
};
